import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isTemporaryItem',
  pure: true,
  standalone: true,
})
export class TemporaryItemPipe implements PipeTransform {
  public transform(value: string | undefined | null): boolean {
    return !!value?.includes('temp-');
  }
}
